<div class="root" *transloco="let t; read:'permit.prepare'">
    <div class="root__loader" *ngIf="loading$ | async"></div>
    <ng-container *ngIf="(loading$ | async) === false">
        <div class="root__intro">{{ t((permitRequests$ | async)?.length > 0 ? "preparedPermitsListIntro" : "preparedPermitsNotFound") }}</div>

        <div class="root__list" *ngIf="(permitRequests$ | async)?.length > 0 && permitRequests$ | async as permitRequests">
            <pmt-permit-request-list-item *ngFor="let permitRequest of permitRequests" [item]="permitRequest">
            </pmt-permit-request-list-item>
        </div>

        <div class="root__refresh" (click)="refresh()">{{ t("refresh") }}</div>
    </ng-container>
    <div class="root__actions">
        <button class="root__actions__cancel" (click)="cancel()">{{ t("cancel") }}</button>
    </div>
</div>
